import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'namingsize',
  standalone: true,
})
export class NamingSizePipe implements PipeTransform {
  transform(text: string, maxCharacters: number): string {
    if (!text) {
      return '';
    }

    if (typeof text !== 'string') {
      text = text as string;
    }

    if (text.length > maxCharacters) {
      return text.substring(0, maxCharacters - 3) + '...';
    }

    const prettyText = text.replace(/_/g, ' ');
    return prettyText;
  }
}
